module.exports = __webpack_public_path__ + "img/sHoney888_193x205.2d46f48e.png";